import React from "react";
import { Container } from "./layout";

export default function Footer() {
  return (
    <div className="bg-dark">
      <Container extraClasses="flex flex-wrap justify-center py-1 text-sm">
        <div className="font-bold uppercase mx-2 w-max">
          <span className="text-red">Maryville. </span>
          <span className="text-white">Many Connections. One </span>
          <span className="text-red">U.</span>
        </div>
        <div className="text-white mx-2 w-max">
          &copy;2020 Maryville University &#124;{" "}
          <a
            href="https://www.maryville.edu/web-accessibility/"
            className="underline hover:text-red focus:text-red"
            target="_blank"
            rel="noreferrer"
          >
            Accessibility Statement
          </a>{" "}
          &#124;{" "}
          <a
            href="https://www.maryville.edu/about/privacy-policy/"
            className="underline hover:text-red focus:text-red"
            target="_blank"
            rel="noreferrer"
          >
            Privacy Policy
          </a>{" "}
          &#124;
          <span className="font-bold">
            <a href="tel:18006279855">1-800-627-9855</a>
          </span>
        </div>
      </Container>
    </div>
  );
}
